import { type ASTExpr } from '../ast';

function toNumberAST(value: ASTExpr | number): ASTExpr {
  return typeof value === 'number' ? { t: 'number', v: value } : value;
}

export function multiplyAST(l: ASTExpr | number, r: ASTExpr | number): ASTExpr {
  return { t: 'binary', l: toNumberAST(l), r: toNumberAST(r), op: '*' };
}

export function divideAST(l: ASTExpr | number, r: ASTExpr | number): ASTExpr {
  return { t: 'binary', l: toNumberAST(l), r: toNumberAST(r), op: '/' };
}

export function addAST(l: ASTExpr | number, r: ASTExpr | number): ASTExpr {
  return { t: 'binary', l: toNumberAST(l), r: toNumberAST(r), op: '+' };
}

export function subtractAST(l: ASTExpr | number, r: ASTExpr | number): ASTExpr {
  return { t: 'binary', l: toNumberAST(l), r: toNumberAST(r), op: '-' };
}
